module.exports = __webpack_public_path__ + "static/media/maximize.3c644a53.svg";